/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
import classNames from 'classnames';
// eslint-disable-next-line no-restricted-imports
import { IconName } from 'common/components/controls/icon';
// eslint-disable-next-line no-restricted-imports
import { Noun, Verb } from 'common/debug/analytics-constants';
// eslint-disable-next-line no-restricted-imports
import { isGammaNotificationsEnabled } from 'common/lib/feature-flag-client';
// eslint-disable-next-line no-restricted-imports
import HeaderButton from 'components/header/button';
// eslint-disable-next-line no-restricted-imports
import { NotificationsPopoverId } from 'components/popovers/popover-ids';
// eslint-disable-next-line no-restricted-imports
import Analytics from 'debug/analytics';
// eslint-disable-next-line no-restricted-imports
import { showPopover, State } from 'modules';
// eslint-disable-next-line no-restricted-imports
import {
  loadNotificationGroups,
  loadUnreadNotificationsCount,
} from 'modules/loaders/load-notifications';
import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import FavIcon from 'scripts/lib/favicon.coffee';
// eslint-disable-next-line no-restricted-imports
import { memberHasOtherNotifications } from 'selectors/members';
// eslint-disable-next-line no-restricted-imports
import { getUnseenNotificationsCount } from 'selectors/notifications';
// eslint-disable-next-line no-restricted-imports
import { isPopoverShown } from 'selectors/popovers';
import ClassicNotificationsMenuButton from './classic-notifications-menu-button';
import styles from './styles.less';

const HeaderNotificationsMenuPromise = import(/* webpackChunkName: "gamma-notifications-menu-popover" */ 'components/popovers/header-notifications-menu');
const HeaderNotificationsMenu = lazy(() => HeaderNotificationsMenuPromise);

interface NotificationsMenuButtonProps {
  isActive: boolean;
  loadNotificationGroups: () => void;
  onClick: (isActive: boolean) => void;
  loadUnreadNotificationsCount: () => void;
  hasOtherNotifications: boolean;
  unreadNotificationsCount: number;
}

export class NotificationsMenuButtonUnconnected extends React.Component<
  NotificationsMenuButtonProps
> {
  notificationsMenuButtonRef = React.createRef<HTMLButtonElement>();

  componentDidMount() {
    this.props.loadUnreadNotificationsCount();
    this.props.loadNotificationGroups();
  }

  componentDidUpdate(prevProps: NotificationsMenuButtonProps) {
    if (
      prevProps.unreadNotificationsCount === 0 &&
      !this.props.hasOtherNotifications &&
      this.props.unreadNotificationsCount > 0
    ) {
      FavIcon.setNotifications(true);
    }

    if (
      prevProps.unreadNotificationsCount > 0 &&
      !this.props.hasOtherNotifications &&
      this.props.unreadNotificationsCount === 0
    ) {
      FavIcon.setNotifications(false);
    }
  }

  render() {
    const {
      hasOtherNotifications,
      isActive,
      onClick,
      unreadNotificationsCount,
    } = this.props;

    return (
      <>
        <HeaderButton
          icon={IconName.Notification}
          onClick={() => onClick(isActive)}
          ref={this.notificationsMenuButtonRef}
          testId={HeaderTestIds.NotificationsButton}
          className={classNames({
            [styles.newNotifications]:
              !hasOtherNotifications && unreadNotificationsCount > 0,
            [styles.hasOtherNotifications]: hasOtherNotifications,
          })}
        />
        {isActive && (
          <Suspense fallback={null}>
            <HeaderNotificationsMenu
              target={() => this.notificationsMenuButtonRef.current}
            />
          </Suspense>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: State) => {
  return {
    isActive: isPopoverShown(state, NotificationsPopoverId),
    unreadNotificationsCount: getUnseenNotificationsCount(state),
    hasOtherNotifications: memberHasOtherNotifications(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<State>) => {
  return {
    loadNotificationGroups() {
      dispatch(loadNotificationGroups());
    },
    onClick(isActive: boolean) {
      Analytics.trackUE({
        category: Noun.HEADER,
        verb: isActive ? Verb.CLOSES : Verb.OPENS,
        directObj: Noun.NOTIFICATIONS_MENU,
        method: 'by clicking the header button',
      });
      dispatch(showPopover({ name: NotificationsPopoverId }));
    },
    loadUnreadNotificationsCount() {
      dispatch(loadUnreadNotificationsCount());
    },
  };
};

const GammaNotificationsMenuButton = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationsMenuButtonUnconnected);

export default () => {
  const USE_GAMMA_NOTIFICATIONS = isGammaNotificationsEnabled();

  return USE_GAMMA_NOTIFICATIONS ? (
    <GammaNotificationsMenuButton />
  ) : (
    <ClassicNotificationsMenuButton />
  );
};



// WEBPACK FOOTER //
// ./app/gamma/src/components/header/notifications-menu-button/index.tsx